import { api } from '@app/shared';

export default async function fetchReaders() {
  const { data } = await api.reader.get();

  return data;
}

export type FetchReadersData = Awaited<ReturnType<typeof fetchReaders>>;
